import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import style from '../css/SearchBooking.module.css';
import HeaderBarBack from '../components/HeaderBarBack';

const SearchBooking = () => {
	const [orderNumber, setOrderNumber] = useState('');
	const [bookingData, setBookingData] = useState(null);
	const [agentData, setAgentData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const navigate = useNavigate();

	const handleInputChange = (e) => {
		setOrderNumber(e.target.value);
		setError('');
	};

	const fetchAgentDetails = async (agentId) => {
		try {
			const response = await axios.get(
				`https://hometech-repairs.in/homeTech/FetchAgent.php?id=${agentId}`
			);
			if (response.data.status) {
				setAgentData(response.data.data);
			} else {
				setAgentData(null);
			}
		} catch (err) {
			console.error('Error fetching agent details:', err);
			setAgentData(null);
		}
	};

	const handleSearch = async () => {
		if (!orderNumber) {
			setError('Please enter an Order Number');
			return;
		}

		setLoading(true);
		setBookingData(null);
		setAgentData(null);
		setError('');

		try {
			const response = await axios.get(
				`https://hometech-repairs.in/homeTech/FetchBooking.php?order_number=${orderNumber}`
			);

			if (response.data.status) {
				const booking = response.data.data;
				setBookingData(booking);

				// Fetch agent details separately if agent_id is available
				if (booking.agent_id) {
					await fetchAgentDetails(booking.agent_id);
				}
			} else {
				setError('No booking found for this Order Number');
			}
		} catch (err) {
			setError('Error fetching booking details. Try again.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={style.container}>
			<HeaderBarBack title="Search Booking" />

			<div className={style.searchBox}>
				<input
					type="text"
					placeholder="Enter Order Number"
					value={orderNumber}
					onChange={handleInputChange}
					className={style.input}
				/>
				<button onClick={handleSearch} className={style.searchButton}>
					Search
				</button>
			</div>

			{loading && <p className={style.loading}>Loading...</p>}
			{error && <p className={style.error}>{error}</p>}

			{bookingData && (
				<div className={style.bookingDetails}>
					<h3>Booking Details</h3>
					<p className={style.date}>
						{new Date(bookingData.date).toLocaleDateString('en-GB')}
					</p>
					<p className={style.orderNumber}>Order: {bookingData.order_number}</p>

					<p
						className={`${style.status} ${
							bookingData.status === 'Completed'
								? style.completed
								: style.pending
						}`}
					>
						{bookingData.status}
					</p>

					<div className={style.details}>
						<h3>Customer Details</h3>
						<p>
							<strong>Name:</strong> {bookingData.name}
						</p>
						<p>
							<strong>Phone:</strong> {bookingData.phone}
						</p>
						<p>
							<strong>Email:</strong> {bookingData.email}
						</p>
						<p>
							<strong>Service:</strong> {bookingData.service}
						</p>
						<p>
							<strong>Location:</strong> {bookingData.location}
						</p>
						<p>
							<strong>Message:</strong> {bookingData.message}
						</p>
					</div>

					{/* Agent Details */}
					{agentData ? (
						<div className={style.agentDetails}>
							<h3>Agent Details</h3>
							<p>
								<strong>Name:</strong> {agentData.name}
							</p>
							<p>
								<strong>Phone:</strong> {agentData.phone}
							</p>
							<p>
								<strong>Agent ID:</strong> {agentData.agent_id}
							</p>
						</div>
					) : (
						<p className={style.noAgent}>No agent assigned</p>
					)}

					{/* View Invoice Button */}
					{bookingData.status === 'Completed' && (
						<button
							className={style.invoiceButton}
							onClick={() => navigate(`/invoices/${bookingData.order_number}`)}
						>
							View Invoice
						</button>
					)}
				</div>
			)}
		</div>
	);
};

export default SearchBooking;
